module.exports = __webpack_public_path__ + "img/fi-rr-vector-alt.dea2173c.svg";